import { apiClient, queryClient } from '@tasama/api-client-query';
import { env } from './env';
import { computeUploadTimeout } from '@tasama/utils';
import { i18n } from '@tasama/i18n';

/**
 * API Configuration for Onboarding App
 * Configures the API client with base URL and cookie credentials
 */

const API_BASE_URL = env.API_BASE_URL;

// Send Accept-Language on every request based on the active locale
apiClient.setLocaleGetter(() => i18n.language);

// Configure the API client with base URL
apiClient.updateConfig({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Configure Axios to include cookies with requests
apiClient.axios.defaults.withCredentials = true;

// Extend timeout for Business Advisor routes — LLM cold start can take 15–60s.
// Covers both /business-advisor/* (unauthenticated) and /business-advisor-user/*
// (authenticated) — getBusinessAdvisorUrl() in @tasama/business-advisor selects
// the path based on auth state.
apiClient.axios.interceptors.request.use((config) => {
  if (config.url?.includes('/business-advisor')) {
    config.timeout = 90_000;
  }
  return config;
});

// Extend timeout for multipart/file upload requests. Derives both total bytes
// and file count from FormData so the timeout covers the full BFF processing
// chain: upload to file service (Leg 1) + downstream API call (Leg 2).
apiClient.axios.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    let totalBytes = 0;
    let fileCount = 0;
    config.data.forEach((value: FormDataEntryValue) => {
      if (value instanceof Blob) {
        totalBytes += value.size;
        fileCount++;
      }
    });
    if (totalBytes > 0) {
      config.timeout = computeUploadTimeout(totalBytes, fileCount);
    }
  }
  return config;
});

export { apiClient, queryClient };
